import throttle from 'lodash.throttle'

import { App } from '../../App'

export default {
  install(editor) {
    const listeners = new WeakMap()
    editor.on('rendernode', ({ el, node }) => {
      if (!listeners.has(el)) {
        // Register the element in map
        listeners.set(el, true)
  
        const element = document.getElementById('hover-node-card')
        
        // Handles hovering over node
        el.addEventListener('mouseenter', (e) => {
          e.stopPropagation()
          
          // Empties card-body's html
          if (element.childNodes[0] && element.childNodes[0].childNodes[1]) {
            element.childNodes[0].childNodes[1].innerHTML = ''
          }
          
          App.handleNodeHover(node, editor, element)
          
          element.classList.remove('d-none')
        })     
  
        // Makes sure listener of mouseleave calls only once at a specific interval
        el.addEventListener('mouseleave', throttle((e) => {
          e.stopPropagation()
          element.classList.add('d-none')
        }, 3000))     
      }
    })
  }
}